// GENERATED by public/assets/town/_src/gen_atlas.py: do not edit by hand.
// Tile rects in atlas UV (flipY), [u0, v0, du, dv, repeat(1)|clamp(0)|repeat-u(2)].
export const ATLAS_SIZE = 2048;
export const TILES = {
  clap: [0.003906, 0.808594, 0.187500, 0.187500, 1],
  batten: [0.693848, 0.675781, 0.125000, 0.125000, 1],
  shingle: [0.199219, 0.808594, 0.187500, 0.187500, 1],
  corrugated: [0.394531, 0.808594, 0.187500, 0.187500, 1],
  planks: [0.589844, 0.808594, 0.187500, 0.187500, 1],
  brick: [0.826660, 0.675781, 0.125000, 0.125000, 1],
  stone: [0.003906, 0.480469, 0.125000, 0.125000, 1],
  trim: [0.136719, 0.480469, 0.125000, 0.125000, 1],
  rawwood: [0.269531, 0.480469, 0.125000, 0.125000, 1],
  metal: [0.402344, 0.480469, 0.125000, 0.125000, 1],
  plain: [0.535156, 0.480469, 0.125000, 0.125000, 1],
  enamel: [0.667969, 0.480469, 0.125000, 0.125000, 1],
  clap2: [0.785156, 0.808594, 0.187500, 0.187500, 1],
  cobble: [0.003906, 0.613281, 0.187500, 0.187500, 1],
  win0: [0.800781, 0.490234, 0.076660, 0.115234, 0],
  win1: [0.885254, 0.490234, 0.076660, 0.115234, 0],
  win2: [0.003906, 0.357422, 0.076660, 0.115234, 0],
  win3: [0.088379, 0.357422, 0.076660, 0.115234, 0],
  win4: [0.172852, 0.357422, 0.076660, 0.115234, 0],
  winRound: [0.134766, 0.272949, 0.076660, 0.076660, 0],
  shop0: [0.257324, 0.357422, 0.153809, 0.115234, 0],
  shop1: [0.418945, 0.357422, 0.153809, 0.115234, 0],
  shop2: [0.580566, 0.357422, 0.153809, 0.115234, 0],
  doorGreen: [0.199219, 0.666016, 0.063965, 0.134766, 0],
  doorWood: [0.270996, 0.666016, 0.063965, 0.134766, 0],
  doorFridge: [0.342773, 0.666016, 0.063965, 0.134766, 0],
  doorBatwing: [0.414551, 0.666016, 0.063965, 0.134766, 0],
  doorRed: [0.486328, 0.666016, 0.063965, 0.134766, 0],
  sign0: [0.003906, 0.145020, 0.179199, 0.044922, 0],
  sign1: [0.190918, 0.145020, 0.179199, 0.044922, 0],
  sign2: [0.377930, 0.145020, 0.179199, 0.044922, 0],
  sign3: [0.564941, 0.145020, 0.179199, 0.044922, 0],
  sign4: [0.751953, 0.145020, 0.179199, 0.044922, 0],
  sign5: [0.003906, 0.092285, 0.179199, 0.044922, 0],
  sign6: [0.190918, 0.092285, 0.179199, 0.044922, 0],
  sign7: [0.377930, 0.092285, 0.179199, 0.044922, 0],
  sign8: [0.564941, 0.092285, 0.179199, 0.044922, 0],
  sign9: [0.751953, 0.092285, 0.179199, 0.044922, 0],
  rsignHotdog: [0.219238, 0.272949, 0.076660, 0.076660, 0],
  rsignCafe: [0.303711, 0.272949, 0.076660, 0.076660, 0],
  rsignBolt: [0.388184, 0.272949, 0.076660, 0.076660, 0],
  poster0: [0.852539, 0.392578, 0.057617, 0.080078, 0],
  poster1: [0.917969, 0.392578, 0.057617, 0.080078, 0],
  poster2: [0.003906, 0.269531, 0.057617, 0.080078, 0],
  poster3: [0.069336, 0.269531, 0.057617, 0.080078, 0],
  tv: [0.472656, 0.272949, 0.076660, 0.076660, 0],
  washer: [0.742188, 0.370117, 0.102539, 0.102539, 0],
  chalk: [0.810547, 0.279297, 0.051270, 0.070312, 0],
  awnRed: [0.003906, 0.197754, 0.153809, 0.063965, 2],
  awnTeal: [0.165527, 0.197754, 0.153809, 0.063965, 2],
  awnYellow: [0.327148, 0.197754, 0.153809, 0.063965, 2],
  awnBlue: [0.488770, 0.197754, 0.153809, 0.063965, 2],
  bush: [0.557129, 0.272949, 0.076660, 0.076660, 0],
  leaves: [0.558105, 0.672852, 0.127930, 0.127930, 0],
  tufts: [0.003906, 0.039551, 0.153809, 0.044922, 2],
  flowers: [0.641602, 0.272949, 0.076660, 0.076660, 0],
  vine: [0.726074, 0.272949, 0.076660, 0.076660, 0],
  weeds: [0.198730, 0.045898, 0.153809, 0.038574, 2],
  drips: [0.360352, 0.045898, 0.102539, 0.038574, 2],
  bike: [0.650391, 0.197754, 0.102539, 0.063965, 0],
  wheel: [0.760742, 0.197754, 0.063965, 0.063965, 0],
  railing: [0.470703, 0.045898, 0.153809, 0.038574, 2],
  bunting: [0.632324, 0.059082, 0.153809, 0.025391, 2],
  laundry: [0.832520, 0.210449, 0.153809, 0.051270, 2],
  lantern: [0.165527, 0.039551, 0.025391, 0.044922, 0],
} as const;
export type TileName = keyof typeof TILES;
